const path = require('path');
const { initLogger, getLogger, getMiddleware, isNode, stringify } = require('@tyc/logger');
const { applicationName } = require('../configs/application');
const { logger: loggerConfig } = require('../configs/runtime');
const routeRules = require('../configs/routeRules');

try {
  const baseProps = { applicationName, env: process.env.TYC_ENV };
  const isInPod = isNode && process.env.POD_NAME;
  const options = isNode
    ? { logDir: isInPod ? `/data/log/${applicationName}` : path.join(process.cwd(), 'logs') }
    : { clsApi: `${loggerConfig.clsOrigin}/log` };
  options.routeRules = routeRules;
  initLogger(baseProps, options);
} catch (err) {
  // eslint-disable-next-line no-console
  console.error('[@tyc/logger] Init failed', err);
}

const logger = getLogger();
const loggingMiddleware = isNode && getMiddleware();

module.exports = {
  logger,
  loggingMiddleware,
  isNode,
  stringify,
};
